<template>
  <div class="referral-program-page">
    <div class="head">
      <div class="label">{{ $t(`${i18nPrefix}.myProgram`) }}</div>
    </div>
    <div class="content">
      <div v-if="rootCompanyId === 6429" class="hsbc-tip">
        {{ $t(`${i18nPrefix}.HSBCCustomInfo`) }}
      </div>
      <div class="title">
        {{ $t(`${i18nPrefix}.referralProgramTitle`) }}
        <span class="common_style">{{ $t(`${i18nPrefix}.referralProgramPowered`) }}</span>
      </div>
      <div v-if="rootCompanyId === 6429" v-html="$t(`${i18nPrefix}.HSBCReferralProgramIntro}`)" class="label">
      </div>
      <div v-else class="label">
        {{ $t(`${i18nPrefix}.referralProgramIntro`) }}
      </div>
      <div class="title">
        {{ $t(`${i18nPrefix}.earningRewardsTitle`) }}
      </div>
      <div class="label">
        {{ $t(`${i18nPrefix}.earningRewardsIntro`) }}
      </div>
      <div class="title">
        {{ $t(`${i18nPrefix}.howTo_referTitle`) }}
      </div>
      <div class="label">
        {{ $t(`${i18nPrefix}.howTo_referIntro`) }}
      </div>
      <div class="title">
        {{ $t(`${i18nPrefix}.myEarningRewardTitle`) }}
      </div>
      <div class="label">
        {{ $t(`${i18nPrefix}.myEarningRewardIntro`) }}
      </div>
      <div class="title">
        {{ $t(`${i18nPrefix}.aboutTaxTitle`) }}
      </div>
      <div class="label">
        {{ $t(`${i18nPrefix}.aboutTaxIntro`) }}
      </div>
      <div class="title">
        {{ $t(`${i18nPrefix}.contactUsTitle`) }}
      </div>
      <div v-html="$t(`${i18nPrefix}.contactUsIntro`)" class="label">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    personalInfo: {
      type: Object
    }
  },
  data () {
    return {
      i18nPrefix: 'personal.referrals.program'
    }
  },
  computed: {
    rootCompanyId () {
      return this.personalInfo.employee?.company.root_company.id
    }
  }
}
</script>

<style lang="scss" scoped>
.referral-program-page {
  min-height: calc(100vh - var(--header-height, 124px) - 28px);
  min-height: calc(100dvh - var(--header-height, 124px) - 28px);
  background-color: #fff;

  .head {
    display: flex;
    position: sticky;
    top: -14px;
    height: 52px;
    padding: 16px 0 16px 40px;
    z-index: 3;
    background-color: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);

    .label {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      color: #606266;
    }
  }

  .content {
    padding: 40px;
    max-height: calc(100vh - 28px - var(--header-height));
    max-height: calc(100dvh - 28px - var(--header-height));
    line-height: 20px;
    background-color: #fff;

    .hsbc-tip {
      font-weight: bold;
      color: red;
    }

    .title {
      font-weight: bold;
      font-size: 18px;
      line-height: 24px;
      color: #0096cc;
      padding-top: 20px;

      .common_style {
        font-weight: normal;
        font-size: 14px;
        color: #232323;
      }
    }

    .label {
      padding-top: 10px;
    }
  }

}
</style>
